export type DocVersionStatus = "draft" | "published" | "superseded";

export const DOC_VERSION_STATUSES: DocVersionStatus[] = ["draft", "published", "superseded"];

export function isPublishedOrSuperseded(status: string): boolean {
  return status === "published" || status === "superseded";
}

export function canRestoreFromStatus(status: string): boolean {
  return isPublishedOrSuperseded(status);
}
